import React from 'react';

import {wrappedEllipsisText} from './wrapped-ellipsis-text.module.styl';

type Props = {
    text: string,
};

export const WrappedEllipsisText: React.FC<Props> = ({text}) => (
    <div className={wrappedEllipsisText} title={text}>
        {text}
    </div>
);
